//This file is automatically rebuilt by the Cesium build process.
export default "\n\
uniform mat4 shadowMap_cascadeMatrices[4];\n\
\n\
mat4 czm_cascadeMatrix(vec4 weights)\n\
{\n\
    // weights is one-hot (exactly one component is 1.0, rest are 0.0).\n\
    // Use indexed lookup instead of weighted sum of all 4 matrices.\n\
    // Clamp to [0,3] to prevent OOB access if two weights are 1.0 at\n\
    // exact cascade split boundaries (e.g. dot((0,0,1,1), (0,1,2,3)) = 5).\n\
    int index = clamp(int(dot(weights, vec4(0.0, 1.0, 2.0, 3.0))), 0, 3);\n\
    return shadowMap_cascadeMatrices[index];\n\
}\n\
";
